import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import $ from 'jquery';
import Preview from './Preview';
import ProgressBar from '../../../../view/ProgressBar';
import {ContractCreate} from '../../../../view/Messages';
import Data from '../../../../data/StateOptionContract.json';
import FormError from '../../../../view/FormError';
import {Currency, UnCurrency} from '../../../../model/Helper';
import Meta from '../../../../model/Meta';

class OptionContractStep4 extends Component {
    constructor(props) {
        super(props);

        this.state = Data;
    }

    componentWillMount() {

		if(localStorage.getItem(this.state.formId)===null) {
			localStorage.setItem(this.state.formId, JSON.stringify(this.state));
		}

		let data = JSON.parse(localStorage.getItem(this.state.formId));

		if(data){
			this.setState({
				details: data.details
			},			
				()=>{
					//console.log("State default: ", this.state);
					localStorage.setItem(this.state.formId, JSON.stringify(this.state));

					// Initialize errors and callbacks
					this.errorHandle();
				}
			);
		} else {
			localStorage.setItem(this.state.formId, JSON.stringify(this.state));
		}

    }

    componentDidMount() {
		$('html, body').animate({scrollTop: 0}, 300);
	}

	handleChange(event) {
		const target = event.target;
	    let value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;
		
		if(name==="price") {
			value = UnCurrency(value);
			if(value.length>15){
				value = this.state.details.property.price;
			}
		}

		if(name==="optionMoneyAmount") {
			value = UnCurrency(value);
			if(value.length>15){
				value = this.state.details.property.optionMoneyAmount;
			}
		}

		if(name==="daysReserved") {
			if(value.length>15){
				value = this.state.details.property.daysReserved;
			}
		}

	    this.setState({
			details: {
				property: {
					...this.state.details.property,
					[name]: value
				},
				seller: this.state.details.seller,
				buyer: this.state.details.buyer,
				payment: this.state.details.payment
			},
			formFocus: "property_"+name
	    },
	    	()=>{
				//console.log("State Change: ", this.state);
				//console.log("Form focus: ", this.state.formFocus);
	    		localStorage.setItem(this.state.formId, JSON.stringify(this.state));
	    		this.errorHandle();
	    	}
	    );
    }
    
    errorHandle(callback = null) {
        let errorArray = [];

        if(
            this.state.details.property.optionMoneyAmount==="" ||
            this.state.details.property.price==="" ||
            this.state.details.property.daysReserved===""
            ) {
            let err = {
                "message": `All fields are required.`
            }
            errorArray.push(err);
        } 

        ////console.log("Going to state: ", errorArray)
        this.setState({
            formError: errorArray
        },(i)=>{
            ////console.log("Error handle: ", this.state )
            localStorage.setItem(this.state.formId, JSON.stringify(this.state));
            this.checkCompleteness();		
        })

    }

    checkCompleteness() {

		if(this.state.formError.length>0) {
            $(".next").addClass("disabled");
            $(".form-error").removeClass("d-none");
		} else {
            $(".next").removeClass("disabled");
            $(".form-error").addClass("d-none");
		}
			
    }

    render() {
		const meta = {
			title: "Contract Information - Option Contract",
			description: "Enter contract information to create your FREE Option Contract"
		}
        return (
            <div className="page page-inner page-contract">
				<Meta {...meta}/>
				<div className="">
					<div className="">					
						<div className="row">
							<div className="col-12 col-md-5">
								<h4 className="page-title pt-0 pb-3">{this.state.formName}</h4>
								
                                <ContractCreate />
								
								<ProgressBar percentage={Math.floor((4/6)*100)} />

                                <form>

                                    <div className="form-group">
                                        <label htmlFor="optionMoneyAmount">
                                            <span className="font-weight-bold">How much is the option money? (Philippine Peso)?</span><span className="red asterisk">*</span>
                                        </label>
                                        <input className="form-control" name="optionMoneyAmount" type="text" onChange={this.handleChange.bind(this)} value={Currency(this.state.details.property.optionMoneyAmount)} placeholder="(e.g. 50,000)" />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="price">
                                            <span className="font-weight-bold">How much is the selling price of the real property? (Philippine Peso)</span><span className="red asterisk">*</span>
                                        </label>
                                        <input className="form-control" name="price" type="text" onChange={this.handleChange.bind(this)} value={Currency(this.state.details.property.price)} placeholder="(e.g. 10,000,000)" />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="daysReserved">
                                            <span className="font-weight-bold">How many days will the subject property be reserved for the buyer?</span><span className="red asterisk">*</span>
                                        </label>
                                        <input className="form-control" name="daysReserved" type="number" onChange={this.handleChange.bind(this)} value={this.state.details.property.daysReserved} placeholder="(e.g. 30)" />
                                    </div>

                                </form>

                                {/** Navs */}
								<div className="nav-step mt-4">
									<p className="p-0 m-0">Step 4/6</p>
									<FormError errors={this.state.formError} />
									<div className="row">
										<div className="col-6">
											<Link to={this.state.formPath+"/3"} className="btn btn-lightblue w-100">Back</Link>
										</div>
										<div className="col-6">
											<Link to={this.state.formPath+"/5"} className="btn btn-lightblue disabled next w-100">Next</Link>
										</div>
									</div>
								</div>

                            </div>
                            
                            <div className="col-12 col-md-7 right-preview">
								<Preview {...this.state} />
							</div>

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default OptionContractStep4;


// WEBPACK FOOTER //
// ./src/pages/contracts/free-contracts/option-contract/OptionContractStep4.js